import { GroupBox, TextInput } from 'react95';
import { useLocale } from '../i18n/LocaleContext';
import { Block, SectionTitle } from './ui';

const Field = ({ label, value }) => (
  <label style={{ display: 'block', marginBottom: '8px' }}>
    <div style={{ marginBottom: '4px', fontWeight: 'bold' }}>{label}</div>
    <TextInput
      fullWidth
      readOnly
      value={value}
      aria-label={label}
    />
  </label>
);

const formatDuties = (skills) => skills.map((skill) => `* ${skill}`).join('\n');

const Experience = ({ data }) => {
  const { t } = useLocale();
  const labels = t.experience;

  return (
    <>
      <SectionTitle>{labels.title}</SectionTitle>
      {data.companies.map((company) => {
        const duties = formatDuties(company.skills);

        return (
          <Block key={`${company.name}-${company.period}`} aria-label={company.name}>
            <GroupBox label={company.name} style={{ marginBottom: '16px' }}>
              <Field label={labels.role} value={company.role} />
              <Field label={labels.period} value={company.period} />
            </GroupBox>

            <GroupBox label={labels.duties}>
              <TextInput
                multiline
                fullWidth
                disabled
                variant="flat"
                rows={Math.max(company.skills.length + 1, 3)}
                value={duties}
                aria-label={labels.duties}
                style={{ marginTop: '4px' }}
              />
            </GroupBox>
          </Block>
        );
      })}
    </>
  );
};

export default Experience;
